var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    {
      attrs: { show: _vm.show },
      model: {
        value: _vm.show,
        callback: function($$v) {
          _vm.show = $$v
        },
        expression: "show"
      }
    },
    [
      _c(
        "CabeceraModal",
        {
          attrs: { titulo: "Ordenes de Servicio" },
          on: { cerrar: _vm.closeModal }
        },
        [
          _c(
            "div",
            {
              staticClass: "numero_sim",
              staticStyle: {
                "letter-spacing": "0.02em",
                "white-space": "nowrap",
                overflow: "hidden",
                "text-overflow": "ellipsis",
                "margin-top": "16px"
              }
            },
            [
              _c(
                "div",
                { staticClass: "boton_crear", staticStyle: { height: "37px" } },
                [
                  _vm.accion_modal == "CREAR"
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "icon",
                          staticStyle: {
                            "background-color": "#ff6c00 !important",
                            "border-color": "#ff6c00 !important",
                            "padding-right": "20px",
                            display: "block",
                            margin: "0 0 0 auto"
                          },
                          attrs: {
                            color: "primary",
                            disabled: _vm.btnCrear_disabled == true
                          },
                          on: {
                            click: function($event) {
                              return _vm.crear()
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "color-blanco",
                              staticStyle: { color: "white" }
                            },
                            [_vm._v("GUARDAR")]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.accion_modal == "EDITAR" && _vm.disabled_anulada == false
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "icon",
                          staticStyle: {
                            "background-color": "#ff6c00 !important",
                            "border-color": "#ff6c00 !important",
                            "padding-right": "20px",
                            display: "block",
                            margin: "0 0 0 auto"
                          },
                          attrs: { color: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.editar()
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "color-blanco",
                              staticStyle: { color: "white" }
                            },
                            [_vm._v("GUARDAR CAMBIOS")]
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ]
      ),
      _c(
        "v-card",
        { attrs: { height: "55px", flat: "" } },
        [
          _c(
            "v-bottom-nav",
            {
              attrs: {
                value: true,
                active: _vm.pasos.informacionGeneral.step,
                absolute: "",
                color: "transparent"
              },
              on: {
                "update:active": function($event) {
                  return _vm.$set(_vm.pasos.informacionGeneral, "step", $event)
                }
              }
            },
            [
              _c(
                "v-btn",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.pasos.informacionGeneral.visible,
                      expression: "pasos.informacionGeneral.visible"
                    }
                  ],
                  attrs: {
                    color: "primary",
                    flat: "",
                    value: _vm.pasos.informacionGeneral.step
                  },
                  on: { click: _vm.handleInfoGeneral }
                },
                [
                  _c("span", [_vm._v("Detalle")]),
                  _c("v-icon", [_vm._v("info")])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showInfo,
              expression: "showInfo"
            }
          ],
          staticClass: "cardnew",
          attrs: { align: "center" }
        },
        [
          _c("br"),
          _c(
            "div",
            { staticClass: "orden_compra", attrs: { align: "center" } },
            [
              _c(
                "v-flex",
                { attrs: { md10: "" } },
                [
                  _c(
                    "v-card",
                    { staticClass: "rounded-card" },
                    [
                      _c(
                        "v-form",
                        {
                          ref: "form",
                          staticClass: "col-md-12",
                          attrs: { "lazy-validation": "" }
                        },
                        [
                          _c(
                            "v-container",
                            { attrs: { "grid-list-md": "" } },
                            [
                              _vm.accion_modal == "EDITAR"
                                ? _c(
                                    "h3",
                                    {
                                      staticStyle: {
                                        color: "#27488e !important"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                Orden de Servicio: " +
                                          _vm._s(_vm.numero_orden) +
                                          " -\n                " +
                                          _vm._s(_vm.data["Número de Alta"]) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm.accion_modal == "CREAR"
                                ? _c(
                                    "h3",
                                    {
                                      staticStyle: {
                                        color: "#27488e !important"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                Crear Alta Servicio\n              "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "v-toolbar",
                                [
                                  _c(
                                    "v-tabs",
                                    {
                                      attrs: { centered: "" },
                                      model: {
                                        value: _vm.tabs,
                                        callback: function($$v) {
                                          _vm.tabs = $$v
                                        },
                                        expression: "tabs"
                                      }
                                    },
                                    [
                                      _c("v-tabs-slider", {
                                        attrs: { color: "yellow" }
                                      }),
                                      _c("v-tab", [_vm._v("Cabecera")]),
                                      _c("v-tab", [_vm._v("Detalle")]),
                                      _c("v-tab", [_vm._v("Movimientos Serie")])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-tabs-items",
                                {
                                  model: {
                                    value: _vm.tabs,
                                    callback: function($$v) {
                                      _vm.tabs = $$v
                                    },
                                    expression: "tabs"
                                  }
                                },
                                [
                                  _c(
                                    "v-tab-item",
                                    [
                                      _c(
                                        "v-card",
                                        { attrs: { flat: "" } },
                                        [
                                          _c(
                                            "FormFieldsContainer",
                                            {
                                              attrs: {
                                                titulo: "Orden de Servicio"
                                              }
                                            },
                                            [
                                              _c(
                                                "v-flex",
                                                { attrs: { sm3: "", md3: "" } },
                                                [
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      "prepend-icon": "123",
                                                      label: "Número de Orden",
                                                      readonly: ""
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.data[
                                                          "Numero Orden"
                                                        ],
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.data,
                                                          "Numero Orden",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "data['Numero Orden']"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-flex",
                                                { attrs: { sm3: "", md3: "" } },
                                                [
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      "prepend-icon": "123",
                                                      color: "primary",
                                                      label: "Caso",
                                                      readonly: ""
                                                    },
                                                    model: {
                                                      value: _vm.data["Caso"],
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.data,
                                                          "Caso",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "data['Caso']"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-flex",
                                                { attrs: { sm3: "", md3: "" } },
                                                [
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      "prepend-icon":
                                                        "calendar_month",
                                                      color: "primary",
                                                      label: "Fecha SerTec",
                                                      readonly: ""
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.data[
                                                          "Fecha Sertec"
                                                        ],
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.data,
                                                          "Fecha Sertec",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "data['Fecha Sertec']"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-flex",
                                                { attrs: { sm3: "", md3: "" } },
                                                [
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      label:
                                                        "Fecha de Registro",
                                                      "prepend-icon":
                                                        "calendar_month",
                                                      readonly: ""
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.data[
                                                          "Fecha de Registro"
                                                        ],
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.data,
                                                          "Fecha de Registro",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "data['Fecha de Registro']"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-flex",
                                                { attrs: { sm3: "", md3: "" } },
                                                [
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      label: "Cliente",
                                                      "prepend-icon":
                                                        "supervisor_account",
                                                      readonly: ""
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.data["Cliente"],
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.data,
                                                          "Cliente",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "data['Cliente']"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-flex",
                                                { attrs: { sm3: "", md3: "" } },
                                                [
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      label: "Coordinador",
                                                      "prepend-icon":
                                                        "supervisor_account",
                                                      readonly: ""
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.data["Coordinador"],
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.data,
                                                          "Coordinador",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "data['Coordinador']"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-flex",
                                                { attrs: { sm3: "", md3: "" } },
                                                [
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      label: "Técnico",
                                                      "prepend-icon":
                                                        "supervisor_account",
                                                      readonly: ""
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.data["Técnico"],
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.data,
                                                          "Técnico",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "data['Técnico']"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-flex",
                                                { attrs: { sm3: "", md3: "" } },
                                                [
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      "prepend-icon":
                                                        "description",
                                                      label: "Tipo Trabajo",
                                                      readonly: ""
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.data[
                                                          "Tipo Trabajo"
                                                        ],
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.data,
                                                          "Tipo Trabajo",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "data['Tipo Trabajo']"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-flex",
                                                { attrs: { sm3: "", md3: "" } },
                                                [
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      "prepend-icon":
                                                        "directions_car",
                                                      label: "Patente",
                                                      readonly: ""
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.data["Patente"],
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.data,
                                                          "Patente",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "data['Patente']"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-flex",
                                                { attrs: { sm3: "", md3: "" } },
                                                [
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      "prepend-icon":
                                                        "directions_car",
                                                      color: "primary",
                                                      label: "Marca Vehículo",
                                                      id: "marca",
                                                      readonly: ""
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.data[
                                                          "Marca Vehículo"
                                                        ],
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.data,
                                                          "Marca Vehículo",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "data['Marca Vehículo']"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-flex",
                                                { attrs: { sm3: "", md3: "" } },
                                                [
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      "prepend-icon":
                                                        "directions_car",
                                                      label: "Modelo Vehículo",
                                                      readonly: ""
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.data[
                                                          "Modelo Vehículo"
                                                        ],
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.data,
                                                          "Modelo Vehículo",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "data['Modelo Vehículo']"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-flex",
                                                { attrs: { sm3: "", md3: "" } },
                                                [
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      type: "number",
                                                      maxlength: "4",
                                                      "prepend-icon":
                                                        "directions_car",
                                                      color: "primary",
                                                      label: "Año Vehículo",
                                                      readonly: ""
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.data[
                                                          "Año Vehículo"
                                                        ],
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.data,
                                                          "Año Vehículo",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "data['Año Vehículo']"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-flex",
                                                { attrs: { sm3: "", md3: "" } },
                                                [
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      label: "Clasificación",
                                                      "prepend-icon":
                                                        "description",
                                                      readonly: ""
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.data[
                                                          "Clasificacion"
                                                        ],
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.data,
                                                          "Clasificacion",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "data['Clasificacion']"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-tab-item",
                                    [
                                      _c("v-card", { attrs: { flat: "" } }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "gridcard2 rounded-card2 orden_compra2"
                                          },
                                          [
                                            _vm.accion_modal == "CREAR"
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "layout row wrap",
                                                    staticStyle: {
                                                      "padding-right": "0px",
                                                      "padding-left": "10px"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "flex xs12 sm6 md2",
                                                        attrs: {
                                                          align: "right"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "v-btn",
                                                          {
                                                            staticClass:
                                                              "btn-crear v-btn theme--light",
                                                            on: {
                                                              click:
                                                                _vm.modal_abre_crear_detalle_alta
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "i",
                                                              {
                                                                staticClass:
                                                                  "v-icon v-icon--left material-icons theme--dark",
                                                                staticStyle: {
                                                                  color: "black"
                                                                },
                                                                attrs: {
                                                                  "aria-hidden":
                                                                    "true"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "add_circle_outline"
                                                                )
                                                              ]
                                                            ),
                                                            _c("span", [
                                                              _vm._v("Agregar")
                                                            ])
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _c(
                                              "v-flex",
                                              {
                                                attrs: { xs12: "", "mt-2": "" }
                                              },
                                              [
                                                _c("MantenedorGridSinCodigo", {
                                                  attrs: {
                                                    "grid-options":
                                                      _vm.gridOptions2,
                                                    "funcionalidad-id":
                                                      _vm.funcionalidad,
                                                    mostrarAcciones:
                                                      _vm.accion_modal ==
                                                      "CREAR",
                                                    quitarCheckOut: true
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ])
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-tab-item",
                                    [
                                      _c("v-card", { attrs: { flat: "" } }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "gridcard2 rounded-card2 orden_compra2 mb-5"
                                          },
                                          [
                                            _c(
                                              "v-flex",
                                              {
                                                attrs: { xs12: "", "mt-2": "" }
                                              },
                                              [
                                                _c("MantenedorGridSinCodigo", {
                                                  attrs: {
                                                    "grid-options":
                                                      _vm.gridOptions3,
                                                    "funcionalidad-id":
                                                      _vm.funcionalidad,
                                                    mostrarAcciones:
                                                      _vm.accion_modal ==
                                                      "CREAR",
                                                    quitarCheckOut: true
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c("TablaSeriesTodos", {
        ref: "TablaSeriesTotales",
        attrs: {
          DispositivosTotalesPorTecnico: _vm.AltaServicioDetalleModalState,
          id_tecnico_seleccionado: _vm.model_filtro_tecnico,
          id_alta_serv: _vm.model_altasernumero
        },
        on: {
          cerrarModal: function($event) {
            return _vm.cerrarModalDetalleAlta()
          },
          selected: function($event) {
            return _vm.cargarDetalleAlta($event)
          }
        }
      }),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.mostrarModalCONFIRMAR,
          titulo: _vm.$t("Confirmación"),
          mensaje: _vm.Modal_confirmar_TEXTO,
          textoBtnSi: _vm.$t("mensajes.crud.crear.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.crud.crear.btnCancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.confirmCallback($event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }